import type { Option } from '@/stores/store-interfaces';

const RAW_OPTION: Option = { label: 'Raw', value: 'raw' };

function aggregatedOptions(dataType: string): Option[] {
    if (dataType === 'energy') {
        return [{ label: 'Sum', value: 'sum' }];
    }
    if (['pue', 'temperature', 'humidity'].includes(dataType)) {
        return [
            { label: 'Mean', value: 'mean' },
            { label: 'Max', value: 'max' },
        ];
    }
    // Power and others
    return [
        { label: 'Sum', value: 'sum' },
        { label: 'Max', value: 'max' },
    ];
}

/** Aggregate choices for a BMS data type; Raw is offered only to organizations entitled to raw sensor data. */
export function getAggregateOptions(dataType: string, { includeRaw }: { includeRaw: boolean }): Option[] {
    const options = aggregatedOptions(dataType);
    return includeRaw ? [...options, RAW_OPTION] : options;
}
